module.exports = __webpack_public_path__ + "img/meme_19.6de8da8a.jpg";